import React from 'react';
import '../base/CustomMarkDownArea.scss';

import { isLongScreen } from '../../utils/ScreenUtil';
import { useFormContext } from 'react-hook-form';
import { EarningRuleErrorHandleField } from '../earning/EarningRuleHandleError';
import ReactHookFormTextInput from 'components/reactHookFormComponents/ReactHookFormTextInput';

function OverviewSection(props) {
  const { register } = useFormContext();
  return (
    <ReactHookFormTextInput
      title="Name"
      valueFieldName="name"
      errorId="name"
      customClass={isLongScreen ? '' : 'custom-markdown-area-title-short'}
      {...register("name", { required: `${EarningRuleErrorHandleField.generalName.message}` })}
    />
  );
}

export default OverviewSection;
